import request from "./request";
import auth from "./auth";
import Qs from "qs";
export function refreshToken(refreshData, appCode) {
  let userData = { switch_user_name: "", logout_user_name: "" };
  let new_data = refreshData ? { ...userData, ...refreshData } : userData;
  let appHeader = appCode ? { "app-code": appCode } : {};
  let data = {
    grant_type: "refresh_token",
    refresh_token: auth.getLoginInfo("refresh_token"),
    // logout_user_name: new_data.logout_user_name,//注销用户账户
    // switch_user_name: new_data.switch_user_name,//切换用户账号
  };
  for (let key in new_data) {
    if (new_data[key]) {
      data[key] = new_data[key];
    }
  }
  return request({
    url: "/auth/oauth/token",
    method: "post",
    data: Qs.stringify(data),
    headers: {
      Authorization: "Basic YWRtaW4td2ViOlVWTVI5a1UwVDdQeVBrREV3bUNv",
      "Content-Type": "application/x-www-form-urlencoded",
      ...appHeader,
    },
    otherToken: true,
  });
}
export function windowRefreshToken() {
  const expires_time = parseInt(auth.getLoginInfo("expiresTime"));
  const loginTime = parseInt(auth.getLoginInfo("loginTime"));
  const currentDate = new Date().getTime();
  //loginedTime 已登录时长
  const loginedTime = currentDate - loginTime;
  if (currentDate - loginTime > expires_time * 1000) {
    auth.goLogin(true);
    // auth.removeAllSession();
    // window.location.href = "#/login";
  } else if (expires_time * 1000 - loginedTime < 15 * 60 * 1000) {
    if (!window.isReresh) {
      window.isReresh = true;
      refreshToken()
        .then((res) => {
          window.isReresh = false;
          if (res.code == "00000") {
            auth.saveToken(res.data.access_token);
            //储存登录时间点，过期时间等
            let loginInfo = {
              refresh_token: res.data.refresh_token,
              expiresTime: res.data.expires_in,
              loginTime: new Date().getTime(),
            };
            auth.saveLoginInfo(loginInfo);
          }
        })
        .catch(() => {
          window.isReresh = false;
        });
    }
  }
}
